import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-currency",
  "use": "icon-currency-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-currency\"><defs><style type=\"text/css\"></style></defs><path d=\"M532.48 634.88v-163.84h286.72c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-258.048l272.384-272.384c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-288.768 288.768-4.096 4.096c0-2.048-2.048-2.048-4.096-4.096l-288.768-288.768c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l272.384 272.384H204.8c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h286.72v163.84h-286.72c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h286.72v194.56c0 12.288 8.192 20.48 20.48 20.48s20.48-8.192 20.48-20.48V675.84h286.72c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-286.72z\" p-id=\"2418\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/currency.svg
// module id = Fq0o
// module chunks = 132